import { Component } from '@angular/core';
import { BooleanCheckOrCrossViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-valetstations',
    templateUrl: './valetstations.component.html',
    styleUrls: ['./valetstations.component.scss'],
    standalone: false
})
export class ValetStationsComponent {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Name", "Name"),
    new BooleanCheckOrCrossViewColumn("High Volume Mode", "HighVolumeModeEnabled"),
    new Datalistviewcolumn("Survey Delay", "SurveyDelay"),
    new Datalistviewcolumn("Parking Lots", "ParkingLotCount"),
    new Datalistviewcolumn("Active Sessions", "ActiveSessionsCount")
  ];
}
